import { EPaymentFrequency } from '@if/core/types'
import { useTranslatedOptionEnum } from '@if/mui'
import { FinancingProgramConfig } from '@src/types/Constants'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useMemo } from 'react'

interface UsePaymentFrequencyOptionsProps {
  creditApplication: CreditApplication
  config: FinancingProgramConfig
}

export const usePaymentFrequencyOptions = ({ creditApplication, config }: UsePaymentFrequencyOptionsProps) => {
  const allowedPaymentFrequencies = useMemo(() => {
    const supportedFrequencies = config.frequencyPayments

    if (creditApplication?.isSinglePayment) {
      return supportedFrequencies.filter((freq) => freq === EPaymentFrequency.Single)
    } else {
      return supportedFrequencies.filter(
        (freq) => freq === EPaymentFrequency.Monthly || freq === EPaymentFrequency.BiWeekly,
      )
    }
  }, [creditApplication?.isSinglePayment, config.frequencyPayments])

  const paymentFrequencyOptions = useTranslatedOptionEnum('EPaymentFrequency', allowedPaymentFrequencies, 'enum')

  return paymentFrequencyOptions
}
